module.exports = __webpack_public_path__ + "static/media/ico-menu.3f8cad53.svg";